import { INIT_EVOLUTION } from "@helpers/_constants";
import moment from "moment-timezone";

import { makeActionHandler } from "./_reducerUtils";

const enterpriseEmployeData = {
  initialState: {
    employeList: {
      list: [],
      isLoaded: false,
      isDataOutdated: false,
      isRefreshing: false
    },
    employeListView: {
      filter: {
        employes: [],
        emplacements: [],
        groupes: [],
        showInactive: false,
        searchTerm: ""
      },
      filteredIds: []
    },
    courseAndSalary: {
      list: [],
      isLoaded: false,
      employeId: null,
      isDataOutdated: false,
      isRefreshing: false
    },
    certification: {
      list: [],
      isLoaded: false,
      employeId: null
    },
    formation: {
      list: [],
      isLoaded: false,
      employeId: null
    },
    note: {
      list: [],
      isLoaded: false,
      employeId: null
    },
    noteRH: {
      list: [],
      isLoaded: false,
      employeId: null
    },
    salaryStatistics: {
      list: [],
      details: {},
      filter: {},
      devise: "",
      isLoaded: false,
      pagination: 0,
      isFiltered: false,
      isDataOutdated: false,
      isRefreshing: false
    },
    salaryEvolutions: {
      dataMonth: {},
      dataYears: {},
      filter: {},
      devise: "",
      year: new Date().getFullYear(),
      years: [...INIT_EVOLUTION],
      isLoaded: false,
      isFiltered: false
    },
    salaryTemplates: {
      list: [],
      isLoaded: false
    },
    employeStatistics: {
      data: null,
      isLoadingComposition: false,
      isPagingAge: false,
      isLoadingUnavailability: false,
      filter: {},
      isLoaded: false,
      isFiltered: false,
      isDataOutdated: false,
      isRefreshing: false,
      pagination: {
        antiquity: 0,
        age: 0,
        conge: 0,
        rotation: new Date().getFullYear(),
        compositionStartFilter: moment().startOf("month").format("YYYY-MM-DD"),
        compositionEndFilter: moment().endOf("month").format("YYYY-MM-DD"),
        referenceDate: null
      }
    },
    birthAnniversary: {
      list: [],
      count: 0,
      initial: 0,
      isLoaded: false,
      isFiltered: false,
      isDataOutdated: false,
      isRefreshing: false,
      filter: {}
    },
    hiringAnniversary: {
      list: [],
      count: 0,
      initial: 0,
      isLoaded: false,
      isFiltered: false,
      isDataOutdated: false,
      isRefreshing: false,
      filter: {}
    },
    enterpriseConge: {
      list: [],
      filter: {},
      isLoading: false,
      isLoaded: false,
      isFiltered: false,
      cancelToken: null,
      upToDate: true,
      skipNethrisOnRefresh: false,
      invalidationVersion: 0
    },
    files: {
      list: [],
      employeId: null,
      isLoaded: false,
      isReady: false
    },
    folders: {
      list: [],
      employeId: null,
      isLoaded: false,
      isReady: false
    },
    defaultFolders: {
      list: [],
      isLoaded: false,
      isReady: false
    },
    filesRH: {
      list: [],
      employeId: null,
      isLoaded: false,
      isReady: false
    },
    foldersRH: {
      list: [],
      employeId: null,
      isLoaded: false,
      isReady: false
    },
    allergies: {
      list: [],
      isLoaded: false
    },
    foods: {
      list: [],
      isLoaded: false
    },
    clothes: {
      list: [],
      isLoaded: false
    },
    enterpriseTask: {
      list: [],
      isLoaded: false,
      filter: {},
      isFiltered: false,
      isLoading: false,
      isRefreshing: false,
      isDataOutdated: false,
      invalidationVersion: 0,
      evaluationRequestList: [],
      onboardingTaskList: [],
      surveyRequestList: []
    },
    disciplinary: {
      list: [],
      isLoaded: false,
      employeId: null
    },
    employeeStatus: {
      list: [],
      isLoaded: false,
      employeId: null,
      isLoading: false,
      isRefreshing: false,
      isDataOutdated: false,
      invalidationVersion: 0
    },
    employeListBulk: {
      list: [],
      isLoaded: false,
      isDataOutdated: false,
      isLoading: false,
      invalidationVersion: 0,
      reconciledDeletedEmployeeIds: [],
      isRefreshing: false
    },
    advantageType: {
      list: [],
      isLoaded: false,
      isDataOutdated: false,
      isRefreshing: false,
      invalidationVersion: 0
    },
    employeeNethrisSoldes: {
      data: [],
      employeId: null,
      isLoaded: false
    },
    genderType: {
      list: [],
      isLoaded: false
    }
  },
  handlers: {
    "enterpriseEmployeData/SET_EMPLOYE_LIST": makeActionHandler("employeList"),
    "enterpriseEmployeData/SET_EMPLOYE_LIST_VIEW":
      makeActionHandler("employeListView"),
    "enterpriseEmployeData/SET_COURSE_AND_SALARY":
      makeActionHandler("courseAndSalary"),
    "enterpriseEmployeData/SET_CERTIFICATION":
      makeActionHandler("certification"),
    "enterpriseEmployeData/SET_NOTE": makeActionHandler("note"),
    "enterpriseEmployeData/SET_NOTE_RH": makeActionHandler("noteRH"),
    "enterpriseEmployeData/SET_FORMATION": makeActionHandler("formation"),
    "enterpriseEmployeData/SET_SALARY_STATISTICS":
      makeActionHandler("salaryStatistics"),
    "enterpriseEmployeData/SET_EMPLOYE_STATISTICS":
      makeActionHandler("employeStatistics"),
    "enterpriseEmployeData/SET_SALARY_EVOLUTION":
      makeActionHandler("salaryEvolutions"),
    "enterpriseEmployeData/SET_SALARY_TEMPLATES":
      makeActionHandler("salaryTemplates"),
    "enterpriseEmployeData/SET_BIRTH_ANNIVERSARY":
      makeActionHandler("birthAnniversary"),
    "enterpriseEmployeData/SET_HIRING_ANNIVERSARY":
      makeActionHandler("hiringAnniversary"),
    "enterpriseEmployeData/SET_ENTERPRISE_CONGE":
      makeActionHandler("enterpriseConge"),
    "enterpriseEmployeData/SET_FILES": makeActionHandler("files"),
    "enterpriseEmployeData/SET_PROFILE_FOLDERS": makeActionHandler("folders"),
    "enterpriseEmployeData/SET_DEFAULT_FOLDER":
      makeActionHandler("defaultFolders"),
    "enterpriseEmployeData/SET_FILES_RH": makeActionHandler("filesRH"),
    "enterpriseEmployeData/SET_PROFILE_FOLDERS_RH":
      makeActionHandler("foldersRH"),
    "enterpriseEmployeData/SET_ALLERGIES": makeActionHandler("allergies"),
    "enterpriseEmployeData/SET_FOODS": makeActionHandler("foods"),
    "enterpriseEmployeData/SET_CLOTHES": makeActionHandler("clothes"),
    "enterpriseEmployeData/SET_ENTERPRISE_TASK":
      makeActionHandler("enterpriseTask"),
    "enterpriseEmployeData/SET_EMPLOYEE_STATUS":
      makeActionHandler("employeeStatus"),
    "enterpriseEmployeData/SET_EMPLOYE_LIST_BULK":
      makeActionHandler("employeListBulk"),
    "enterpriseEmployeData/SET_DISCIPLINARY": makeActionHandler("disciplinary"),
    "enterpriseEmployeData/SET_ADVANTAGE_TYPE":
      makeActionHandler("advantageType"),
    "enterpriseEmployeData/SET_GENDER_TYPE": makeActionHandler("genderType"),
    "enterpriseEmployeData/RESET_EMPLOYER_FOLDER": (state) => ({
      ...state,
      files: enterpriseEmployeData.initialState.files,
      folders: enterpriseEmployeData.initialState.folders,
      salaryEvolutions: enterpriseEmployeData.initialState.salaryEvolutions
    }),
    "enterpriseEmployeData/SET_EMPLOYEE_NETHRIS_SOLDE": makeActionHandler(
      "employeeNethrisSoldes"
    ),
    "RESET_ALL": () => enterpriseEmployeData.initialState
  }
};

export default enterpriseEmployeData;
